import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_DELETE_MASTER_DISCOUNT_FILTER } from "../../store/discountfilter/discountfilterActionTypes";
import { useDiscountFilterMaster } from "../../store/discountfilter/reducer";
interface DiscountDeleteProps {
  discountData?: any;
  isOpen: boolean;
  onClose: () => void;
}

const DiscountDeleteConfirmation: React.FC<DiscountDeleteProps> = ({
  isOpen,
  onClose,
  discountData,
}) => {
  const dispatch = useDispatch();
  const {
    masterDiscountfilter: events,
    busy,
    message,
  } = useDiscountFilterMaster();
  const toast = useToast();
  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === discountData._id
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "selected data is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [discountData, events, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Discount</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this discount?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_DISCOUNT_FILTER,
                payload: { _id: discountData._id },
              });
              onClose();
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DiscountDeleteConfirmation;
